/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGenderAndrogyne = createReactComponent("outline", "gender-androgyne", "IconGenderAndrogyne", [["path", { "d": "M13 11l6 -6", "key": "svg-0" }], ["path", { "d": "M9 15m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-1" }], ["path", { "d": "M19 9v-4h-4", "key": "svg-2" }], ["path", { "d": "M16.5 10.5l-3 -3", "key": "svg-3" }]]);

export { IconGenderAndrogyne as default };
//# sourceMappingURL=IconGenderAndrogyne.mjs.map
